import { FALLBACK_PROPERTIES } from '@/lib/properties/fallback-data'

export const EXAMPLE_PROPERTY = FALLBACK_PROPERTIES[0]

export {
  DEVELOPER_EXAMPLE_CONTAINER,
  DEVELOPER_EXAMPLE_INSTALL_SNIPPET,
  DEVELOPER_EXAMPLE_INSTALL_STATUS_URL,
  getDeveloperExampleContainerPayload,
  type ExampleContainerPayload,
} from '@/lib/developer/example-container-payload'
